import { api } from "../../App";
import { createNotification } from "../../components/Notifications/Notifications";
import {
    GET_SPEC_MED_GROUPS,
    GET_SPEC_MED_GROUPS_TEACHERS,
    GET_SPEC_MED_GROUPS_STUDENTS,
    GET_SPEC_MED_GROUPS_GROUPS,
    GET_ATTACHED_STUDENTS
} from "../types";

export const getSpecMedGroups = (year) => async (dispatch, getState) => {
    try {
        const urlParams = new URLSearchParams(year).toString();
        const { data } = await api.get(`/specmedgroup?${urlParams}`);
        dispatch({ type: GET_SPEC_MED_GROUPS, payload: data });
    } catch (error) {
    }
};

export const getAttachedStudents = (aid) => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/specmedgroup/${aid}`);
        dispatch({ type: GET_ATTACHED_STUDENTS, payload: data });
    } catch (error) {
    }
};

export const getSpecMedGroupsTeachers = () => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/teachers/smg`);
        dispatch({ type: GET_SPEC_MED_GROUPS_TEACHERS, payload: data });
    } catch (error) {
    }
};
export const getSpecMedGroupsStudents = (group) => async (dispatch, getState) => {
    try {
        const urlParams = group !== null ? new URLSearchParams(group).toString() : '';
        const { data } = await api.get(`/people/student/smg?${urlParams}`);
        dispatch({ type: GET_SPEC_MED_GROUPS_STUDENTS, payload: data });
    } catch (error) {
    }
};
export const getSpecMedGroupsGroups = () => async (dispatch, getState) => {
    try {
        const { data } = await api.get(`/groups/year/liter`);
        dispatch({ type: GET_SPEC_MED_GROUPS_GROUPS, payload: data });
    } catch (error) {
    }
};

export const updateSpecMedGroup = (params, aid) => async (dispatch, getState) => {
    const year = { school_year: params.school_year }
    try {
        await api.put(`/specmedgroup/${aid}`, params);
        await dispatch(getSpecMedGroups(year));
    } catch (error) {
    }
}

export const createSpecMedGroup = (data) => async (dispatch, getState) => {
    const year = { school_year: data.school_year }
    try {
        await api.post(`/specmedgroup`, data);
        createNotification('success', 'Успешно');
        await dispatch(getSpecMedGroups(year));
    } catch (error) {
        createNotification('error', "Не удалось создать запись");
    }
};

export const deleteSpecMedGroup = (year, groupsId) => async (dispatch, getState) => {
    try {
        await api.delete(`/specmedgroup/${groupsId}`);
        createNotification('success', 'Успешно');
        await dispatch(getSpecMedGroups(year));
    } catch (error) {
    }
};
//////////